export const  VendorBankColumns = [
    "SNo",
    "BankNames",
    
   
];
